module.exports = __webpack_public_path__ + "static/media/image-3.5eb48661.jpg";